// -----------------------------------------------------------------------------
// SITE CONTENT — Amenity Health Services
// All values below are professional PLACEHOLDERS. Replace them with real,
// confirmed information before launch. Nothing here should be treated as a
// verified medical claim, credential, insurance statement, or testimonial.
// -----------------------------------------------------------------------------

export const site = {
  name: "Amenity Health Services",
  tagline: "Compassionate developmental care for growing children",
  // Main hero benefit headline (edit this to your primary promise)
  heroHeadline: ["Caring support", "that helps children", "find their voice"],
  heroSub:
    "Amenity Health Services and Amenity ABA Center partners with families to support children through speech, behavioral, and developmental care — delivered with warmth, patience, and respect.",

  // Contact — PLACEHOLDER values. Replace with your real details.
  phone: "(346) 333-2794",
  phoneHref: "tel:+13463332794",
  email: "info@amenityhealthsvcs.com",
  address: "4606 FM 1960 W Ste 520, Houston, TX 77069",
  mapLat: 29.9649089,
  mapLng: -95.5408907,
  clinics: [
    {
      name: "North",
      address: "4606 FM 1960 W Ste 520, Houston Texas 77069",
      lat: 29.9649089,
      lng: -95.5408907,
    },
    {
      name: "Houston-West",
      address: "19255 Park Row Blvd #105, Houston Texas 77084",
      lat: 29.7883781,
      lng: -95.6353048,
    },
    {
      name: "Houston-South",
      address: "10435 Greenbough Dr Ste A, Stafford, TX 77477",
      lat: 29.6210934,
      lng: -95.5623413,
    },
  ],
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday – Sunday", time: "Closed" },
  ],

  socials: [
    { label: "Instagram", icon: "instagram", href: "https://www.instagram.com/amenityhouse_" },
    { label: "TikTok", icon: "tiktok", href: "https://www.tiktok.com/@amenityhouse" },
    { label: "Facebook", icon: "facebook", href: "https://www.facebook.com/search/top?q=Amenity%20Health%20Services%20PLLC" },
  ],
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "Contact", to: "/contact" },
];

// Secondary destinations (buttons / footer / mobile menu).
export const secondaryNav = [
  { label: "Schedule a Tour", to: "/schedule-tour" },
  { label: "Join Our Team", to: "/careers" },
];

// Services — confirmed names and descriptions.
export const services = [
  {
    slug: "aba-therapy",
    name: "ABA Therapy",
    short:
      "At its heart, ABA is a personalized approach to learning that uses data to understand and support your child's unique needs. By focusing on essential social, communicative, and self-regulation skills, we provide your family with a roadmap for growth. We aren't just teaching skills; we're building the foundation for your child's next big milestone.",
    for: "Children working on social, communication, and self-regulation skills.",
    includes: [
      "Personalized, data-informed learning plans",
      "Focus on social, communication & self-regulation skills",
      "A clear roadmap toward each next milestone",
    ],
    start: "Request information and our team will walk you through next steps.",
    image:
      "https://images.pexels.com/photos/7156361/pexels-photo-7156361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Children engaged in creative play with educational toys in a cozy, welcoming room.",
  },
  {
    slug: "speech-therapy",
    name: "Speech Therapy",
    short:
      "Speech therapy is the assessment and treatment that addresses various speech and language disorders. Speech therapy is used to help improve deficits by empowering both children and their parents with strategies to help them be successful in interacting with the world around them.",
    for: "Children with speech and language differences — and their parents.",
    includes: [
      "Assessment of speech & language needs",
      "Treatment to improve communication deficits",
      "Strategies that empower both children and parents",
    ],
    start: "Reach out and we'll help you understand how to begin.",
    image:
      "https://images.unsplash.com/photo-1728138240695-54ebc33215f2",
    alt: "A therapist playing with a young child using colorful toys during a speech session.",
  },
  {
    slug: "physical-therapy",
    name: "Physical Therapy",
    short:
      "As movement experts, Physical Therapy at Amenity House focuses on promoting development, enhancing learning and independence, reducing pain, improving strength and function, and easing daily challenges for caregivers for a variety of conditions, illnesses, and injuries in persons from birth to 21 years of age. We use a wide range of methods from a play-based approach to more traditional interventions following the most current evidence in the field to address each child's and family's needs!",
    for: "Children from birth to 21 years across a range of conditions, illnesses, and injuries.",
    includes: [
      "Play-based and evidence-based interventions",
      "Focus on strength, function & independence",
      "Support that eases daily challenges for caregivers",
    ],
    start: "Contact us to learn what a first visit could look like.",
    image:
      "https://images.unsplash.com/photo-1655842556550-6809c404ce9c",
    alt: "A young child playing with colorful toys on a mat in a bright pediatric therapy gym.",
  },
  {
    slug: "occupational-therapy",
    name: "Occupational Therapy",
    short:
      "At Amenity House, the goal of Occupational therapy is to develop and nurture your child's everyday life skills with an inclusive and patient-centered approach designed with our patients, families, and caregivers in mind to enhance the uniqueness in every child. We do this by teaching and educating our patients on daily life skills such as handwriting, dressing, toilet/potty training, social interaction/engagement, and how to self-regulate, using sensory approaches that require therapeutic and creative interventions for your child's increased independence.",
    for: "Children building everyday life skills with family-centered support.",
    includes: [
      "Handwriting, dressing, and toileting skills",
      "Social interaction, engagement & self-regulation",
      "Sensory-based, creative therapeutic activities",
    ],
    start: "Request information to get started.",
    image:
      "https://images.pexels.com/photos/8770575/pexels-photo-8770575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Two children playing happily together with colorful building blocks on the floor.",
  },
];

export const trustPoints = [
  {
    title: "Family-centered",
    body: "We listen first. Families are partners in every step of a child's care journey.",
  },
  {
    title: "Warm & patient",
    body: "Sessions are gentle, playful, and paced around each child's comfort.",
  },
  {
    title: "Clear communication",
    body: "You'll always know what's happening and what comes next — no jargon.",
  },
  {
    title: "Respectful care",
    body: "Every child and family is met with dignity, kindness, and understanding.",
  },
];

export const marqueeWords = [
  "Compassionate",
  "Patient",
  "Family-first",
  "Respectful",
  "Playful",
  "Encouraging",
  "Trusted",
];

// Real family reviews (names removed for privacy).
export const testimonials = [
  {
    quote:
      "We are so grateful for our son's Occupational Therapist. She is incredibly talented, dedicated, and truly passionate about what she does. She consistently brings creativity and care to every session, and we've seen so much growth in our child because of her.",
    name: "Amenity family",
    role: "3 months ago",
  },
  {
    quote:
      "Seven months ago I arrived at Amenity and I can say that I found two wonderful therapists. I love that there is communication with them; they make me feel welcome when I arrive with my daughters. Thank you, for all your support. Thank you so much for accommodating my schedule when I haven't been able to come. I am very grateful for your work.",
    name: "Amenity family",
    role: "2 months ago",
  },
  {
    quote:
      "We have used Amenity for a few years now and have loved the convenience of being able to have therapy in our home. Our therapist is amazing and has helped our daughter achieve so many speech goals. We don't know what we would have done without her and this facility.",
    name: "Amenity family",
    role: "a year ago",
  },
];

// Team bios are PLACEHOLDERS — add real names, titles, and credentials later.
export const team = [
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Share this team member's background, approach to care, and what families can expect.",
    image:
      "https://images.unsplash.com/photo-1708687045030-26702e62fc65",
    alt: "A member of the care team sharing a joyful high-five with a young child.",
  },
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Introduce experience, specialties, and a personal note that helps families feel welcome.",
    image:
      "https://images.unsplash.com/photo-1533222535026-754c501569dd",
    alt: "Children playing joyfully together outdoors on a sunny day.",
  },
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Add credentials and a warm description once details are confirmed.",
    image:
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c",
    alt: "A group of smiling children making a friendly peace sign together.",
  },
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Highlight this team member's specialty and warm, patient approach with children.",
    image:
      "https://images.pexels.com/photos/8653951/pexels-photo-8653951.jpeg",
    alt: "A therapist engaging attentively with a child during a session in a bright, welcoming office.",
  },
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Describe experience with families and what makes sessions feel safe and encouraging.",
    image:
      "https://images.pexels.com/photos/7447271/pexels-photo-7447271.jpeg",
    alt: "A child holding a plush toy listening during a gentle therapy session.",
  },
  {
    name: "[Team Member Name]",
    role: "[Title / Credentials — Placeholder]",
    bio: "Short biography placeholder. Introduce this team member's role in supporting each child's developmental goals.",
    image:
      "https://images.unsplash.com/photo-1685362158423-abf004b858d2",
    alt: "A caregiver and a young child playing together on a rocking chair in a bright room.",
  },
];

export const whoWeServe = [
  {
    key: "patients",
    title: "Patients & Clients",
    body: "Children and young people receiving care, supported in a comfortable, welcoming environment tailored to their needs.",
  },
  {
    key: "families",
    title: "Families & Caregivers",
    body: "Parents, guardians, and caregivers who are partners in care — kept informed, supported, and never left guessing.",
  },
  {
    key: "referrals",
    title: "Referral Partners",
    body: "Physicians, educators, and community partners who refer families to us and collaborate on continuity of care.",
  },
];

// Service areas served.
export const serviceAreas = [
  "Houston, TX",
];

// Roles for the Join Our Team page (editable placeholders).
export const positions = [
  "ABA Therapist / RBT",
  "BCBA (Board Certified Behavior Analyst)",
  "Speech-Language Pathologist",
  "Occupational Therapist",
  "Physical Therapist",
  "Administrative / Front Desk",
  "Other",
];

// Tour time slots based on business hours (Mon–Fri, 8 AM–6 PM).
export const tourTimeSlots = [
  "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM",
  "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM",
  "4:00 PM", "5:00 PM",
];

// Insurances accepted (logos in /public/brand where provided).
export const insurances = [
  { name: "Cigna", logo: "/brand/ins-cigna.webp" },
  { name: "Aetna", logo: "/brand/ins-aetna.png" },
  { name: "Blue Cross Blue Shield of Texas", logo: "/brand/ins-bcbs.png" },
  { name: "UnitedHealthcare", logo: "/brand/ins-uhc.png" },
  { name: "Texas Medicaid", logo: "/brand/ins-txmedicaid.png" },
  { name: "Community Health Choice", logo: "/brand/ins-chc.jpeg" },
  { name: "Texas Children's Health Plan", logo: "/brand/ins-txchildrens.jpeg" },
  { name: "Molina Healthcare", logo: "/brand/ins-molina.jpeg" },
  { name: "Superior HealthPlan", logo: "/brand/ins-superior.jpeg" },
];
